import { inject } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { RatingLabelService } from '../services/rating-label.service';
import { TokenStorageService } from '../auth/token-storage.service';
import { EncryptionKeyLoaderService } from './encryption-key-loader.service';
import { AuthService } from '../auth/auth.service';

export function appInitializer() {
  const configService      = inject(AppConfigService);
  const ratingLabelService = inject(RatingLabelService);
  const tokenStorage       = inject(TokenStorageService);
  const encKeyLoader       = inject(EncryptionKeyLoaderService);
  const authService        = inject(AuthService);

  return async () => {
    await configService.load();

    // On page refresh: restore user state and reload supporting data when a
    // live session exists. First-time login does this inside handleCallback().
    if (tokenStorage.getAccessToken()) {
      const userInfoStr = sessionStorage.getItem('userInfo');
      if (userInfoStr) {
        try {
          authService.currentUser.set(JSON.parse(userInfoStr));
        } catch (_) {}
      }

      await Promise.all([
        ratingLabelService.load(),
        encKeyLoader.load(),
      ]);
    }
  };
}
